import React, { useState } from "react";
import {
  Box,
  Typography,
  FormControlLabel,
  Switch,
  Divider,
  Button,
} from "@mui/material";

const SecurityAndPrivacy = () => {
  const [privacySettings, setPrivacySettings] = useState({
    showProfilePhoto: true,
    listInRegisteredInvestors: true,
  });

  const [notificationSettings, setNotificationSettings] = useState({
    promoEmails: true,
    promoSMS: true,
    promoNotifications: true,
    systemUpdates: true,
  });

  const handlePrivacyChange = (key) => {
    setPrivacySettings((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleNotificationChange = (key) => {
    setNotificationSettings((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <Box sx={{ margin: "0 auto", maxWidth: 800 }}>
      <Typography variant="h6" gutterBottom>
        Gizlilik
      </Typography>
      <Divider sx={{ marginBottom: 3 }} />
      <FormControlLabel
        control={
          <Switch
            checked={privacySettings.showProfilePhoto}
            onChange={() => handlePrivacyChange("showProfilePhoto")}
          />
        }
        label="Profil görselim ve ad/soyad bilgilerim gösterilsin."
        sx={{ marginBottom: 2 }}
      />
      <FormControlLabel
        control={
          <Switch
            checked={privacySettings.listInRegisteredInvestors}
            onChange={() => handlePrivacyChange("listInRegisteredInvestors")}
          />
        }
        label="Profilim kayıtlı yatırımcılar sayfasında listelensin."
        sx={{ marginBottom: 4 }}
      />

      {/* Notifications Section */}
      <Typography variant="h6" gutterBottom>
        Bildirimler
      </Typography>
      <Divider sx={{ marginBottom: 3 }} />
      <FormControlLabel
        control={
          <Switch
            checked={notificationSettings.promoEmails}
            onChange={() => handleNotificationChange("promoEmails")}
          />
        }
        label="Yeni girişimler, yayınlar ve fırsatlarla ilgili tanıtım mailleri almak istiyorum."
        sx={{ marginBottom: 2 }}
      />
      <FormControlLabel
        control={
          <Switch
            checked={notificationSettings.promoSMS}
            onChange={() => handleNotificationChange("promoSMS")}
          />
        }
        label="Yeni girişimler, yayınlar ve fırsatlarla ilgili tanıtım smsleri almak istiyorum."
        sx={{ marginBottom: 2 }}
      />
      <FormControlLabel
        control={
          <Switch
            checked={notificationSettings.promoNotifications}
            onChange={() => handleNotificationChange("promoNotifications")}
          />
        }
        label="Yeni girişimler, yayınlar ve fırsatlarla ilgili tanıtım bildirimleri almak istiyorum."
        sx={{ marginBottom: 2 }}
      />
      <FormControlLabel
        control={
          <Switch
            checked={notificationSettings.systemUpdates}
            onChange={() => handleNotificationChange("systemUpdates")}
          />
        }
        label="Ardventure Kitle Fonlama sistem geliştirmelerinden haberdar olmak istiyorum."
        sx={{ marginBottom: 4 }}
      />

      {/* Save Button */}
      <Box sx={{ textAlign: "right" }}>
        <Button color="primary" variant="contained" size="large">
          Kaydet
        </Button>
      </Box>
    </Box>
  );
};

export default SecurityAndPrivacy;
